import gql from 'graphql-tag'

export const GET_HERO_CONFIG_LIST = gql`
  query {
    heroConfigs {
      id
      heroType
      locationCount
      radius
    }
  }
`

export const GET_HERO_CONFIG_BY_ID = gql`
  query GetHeroConfigById($id: Int!) {
    heroConfig(id: $id) {
      id
      heroType
      locationCount
      radius
    }
  }
`



// WEBPACK FOOTER //
// ./src/graphql/queries/HeroConfig.js